import BasePublicApiClient from '@/clients/BasePublicApiClient'

class LocationsClient extends BasePublicApiClient {
  constructor (practiceUuid) {
    super()
    this.client.defaults.headers.common['practice-uuid'] = practiceUuid
    this.practiceUuid = practiceUuid
  }

  getLocations () {
    return this.getPaginated(`/locations/v1/practices/${this.practiceUuid}/locations`, {}, {}, 'locations')
  }
}

export default LocationsClient
